import React from 'react';
import AchievementImage from '../../Achievements/AchievementImage';
import { getBadgeColor, getAchievementRarity } from '../../../config/badgeColors';

const AchievementSelectorItem = ({ achievement, onSelect }) => {
  const badgeColor = getBadgeColor(achievement);
  const rarity = getAchievementRarity(achievement);

  const handleClick = () => {
    onSelect(achievement);
  };

  const getRarityLabel = (rarity) => {
    return rarity.charAt(0).toUpperCase() + rarity.slice(1);
  };

  const truncateDescription = (description, maxLength = 60) => {
    if (!description || description.length <= maxLength) return description;
    return description.substring(0, maxLength).trim() + '...';
  };

  return (
    <div 
      className="achievement-selector-item"
      onClick={handleClick}
      style={{
        '--item-border-color': badgeColor.borderColor || badgeColor.background,
        '--item-glow-color': badgeColor.glow,
        '--item-bg-color': badgeColor.background
      }}
    >
      <div className="achievement-selector-item__image-container">
        <AchievementImage
          filename={achievement.image_filename}
          alt={achievement.name}
          className="achievement-selector-item__image"
        />
        <div className={`achievement-selector-item__rarity-badge achievement-selector-item__rarity-badge--${rarity}`}>
          {getRarityLabel(rarity)}
        </div>
      </div>
      
      <div className="achievement-selector-item__content">
        <h4 className="achievement-selector-item__name">{achievement.name}</h4>
        <p className="achievement-selector-item__description">
          {truncateDescription(achievement.description)}
        </p>
        
        {achievement.threshold && (
          <div className="achievement-selector-item__threshold">
            Threshold: {achievement.threshold}
          </div>
        )}
      </div>
    </div>
  );
};

export default AchievementSelectorItem;